import routerOptions0 from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: true,
  scrollBehaviorType: "auto"
}
export const hashMode = true
export default {
...configRouterOptions,
...routerOptions0,
}